import React, { useCallback, useRef, useState } from "react";

import { searchConfig } from "config";

const useLastElementRef = (scrollLoading, hasMore, setoffset) => {
  const observer = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (scrollLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setoffset((prevOffset) => prevOffset + searchConfig.pulse.offset);
        }
      });
      if (node) observer.current.observe(node);
    },
    [scrollLoading, hasMore, setoffset]
  );

  return { lastElementRef };
};

export default useLastElementRef;
